import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from '@tanstack/react-query';
import { getHeaders } from "../../../helpers/helper";
import axiosInstance from "../../../shared/config/axiosInstance";
import { QueryKeys } from "../../../shared/react-query/queryKeys";

async function fetchStores(getAccessTokenSilently: any): Promise<any> {
  const headers = await getHeaders(getAccessTokenSilently);
  
  const { data } = await axiosInstance.get('/admin/GetStores', {
    headers
  })

  return data;
}

export const useStores = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: [QueryKeys.STORES],
    queryFn: () => fetchStores(getAccessTokenSilently),
    enabled: !!getAccessTokenSilently,
    staleTime: 0,
    refetchOnMount: true,
  });
};